// extracted by mini-css-extract-plugin
export default {"pointer":"Icon_pointer__wZEEL","iconButton":"Icon_iconButton__tXlIG"};